/*Maintain static name and values*/
export const SPONSOR = 'sponsor'
export const STOREFRONT = 'storefront'
export const MY_SITE_DRAFT = 'preview'
export const MYSITE_SPONSOR = 'mysiteSponsor'
export const MY_SITE_SHOPPING_CONTEXT = 'shoppingContext'
export const NUSKIN_ACCOUNT_DATA = 'nuskin.account.data'
export const CONST_DRAFT = 'draft'
export const CONST_PUBLISHED = 'published'
export const CONST_PERSONAL_OFFER = 'personal_offer'
export const CONST_PRODUCT_OFFER = 'productoffer'
export const CONST_IS_EQUINOX_MYSITE_OR_POSITE = 'isEquinoxMySiteOrPoSite'
export const CONST_UTM_INFO = 'utmInfo'
export const PERSONAL_OFFER = 'personal_offer'

/* Personal Offer (PO) audit localStorage keys */
export const PO_AUDIT_SESSION_ID_KEY = 'po_audit_sessionId'
export const PO_AUDIT_ORDER_OFFERID_KEY = 'po_audit_order_offerid'

/* Personal Offer storage keys */
export const PERSONAL_OFFER_SESSION_KEY = 'personalOffer'
export const PERSONAL_OFFER_V2_KEY = 'personalOffer_v2'
export const PO_LANDING_URL_KEY = 'poLogoutLandingUrl'

export const ADD_CART_GTM = 'addToCart'
export const GTM_METHOD_ADD = 'add'
export const PRODUCT_IMPRESSION_GTM = 'productImpression'
export const GTM_METHOD_IMPRESSION = 'impressions'
export const VIEW_PLP = 'PLP'
export const VIEW_PDP = 'PDP'
export const GRID_COLS = {
  SMALL: 3,
  LARGE: 9,
  FULL: 12,
}

export const SCREEN_BREAKPOINTS = {
  TABLET_MIN: 768,
}
export const MEMBER_PRICE = 'member'
export const RETAIL_PRICE = 'retail'
export const PRICE_FACET_MEMBER = 'Member'
export const PRICE_FACET_WHOLESALE = 'Wholesale'
export const PO_OFFER_STATUS_ACTIVE = 'active'
export const BUNDLE_PRODUCT = 'bundle'
export const KIT_PRODUCT = 'kit'
export const SKU_PRODUCT = 'sku'
export const ACCOUNT_TYPE_MEMBER = 'Preferred Customer/Member'
export const ACCOUNT_TYPE_BRAND_AFFILIATE = 'Brand Affiliate'
export const ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS =
  'Brand Affiliate - Business Entity'
export const RE_ENROLL_TYPE_MEMBER = 'MEMBER'
export const RE_ENROLL_TYPE_BRAND_AFFILIATE = 'BRAND_AFFILIATE'
export const BUNDLE = 'BUNDLE'
export const SKUKIT = 'SKUKIT'
export const FIXED_BUNDLE = 'FIXED_BUNDLE'
export const DEFAULT_SPONSOR = 'nuskin'
export const NUSKIN_DISPLAY_NAME = 'Nuskin'
export const INSIDER_SERVICE = 'Insider'
export const NOT_AVAILABLE = 'NA'

/* Cart payment type values (payment.type on cart response) */
export const PAYMENT_TYPE = {
  CREDITCARD: 'creditcard',
}

/* GPS,SEPA constants */
export const GPS = 'GPS'
export const SEPA = 'sepa'

/* Regex patterns */
export const REGEX_TRAILING_EQUALS = /=(?=&|$)/g
export const REGEX_ABSOLUTE_URL = /^https?:\/\//
export const REGEX_STRIP_PROTOCOL = /^https?:\/\//
export const REGEX_STRIP_WWW = /^www\./
export const REGEX_DOMAIN_SPLIT = /[./]/
export const REGEX_MYSITE_PATH = /\/mysite\/[^/]+/
export const REGEX_PERSONAL_OFFER_PATH = /\/personal-offer\/[^/]+/
export const REGEX_WHITESPACE = /\s+/g
export const REGEX_BARE_PERCENT = /%(?![0-9A-Fa-f]{2})/g
export const REGEX_ESCAPE_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g

/* Date/Time Constants */
export const UNIX_TIMESTAMP_SECONDS_LENGTH = 10 /* Expected length of Unix timestamp in seconds (e.g., 1609459200) */

export const AVAILABLE_CHANNELS = {
  DEFAULT: 'web,mobile,kiosk,arsPhone',
  WITH_SUBSCRIPTION: 'mobile,kiosk,arsPhone,web,subscription',
}

export const PRODUCT_TYPE = {
  BUNDLE: 'BUNDLE',
}

export const PRODUCT_TYPE_CUSTOM = {
  DEVICE: 'device',
}

export const CART_TYPE = {
  EXPRESS: 'EXPRESS',
}

export const SHIPPING_TYPE = {
  PHYSICAL: 'PHYSICAL',
  STORE_PICKUP: 'StorePickup',
  STORE_PICKUP_METHODS: 'STOREPICKUP',
}
